import PropTypes from 'prop-types';
import { initializeMachineApp } from './initializeMachineApp';
import { JQueryWrapper } from '../JQueryWrapper';

export const MachineApp = ({ library }) => {
  return JQueryWrapper({ executeJQueryLogic: navigate => initializeMachineApp(library, navigate) });
};

MachineApp.propTypes = {
  library: PropTypes.object,
};
